// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2F77F","title":"BackImages_title__30TAi","images":"BackImages_images__1HvQs"};